import { useEffect, useState } from 'react';
import { Button, Card } from '../../components/kit';
import { ContractModal } from '../../components/ContractModal';
import { contractsApi, type ContractSummary } from '../../api/contracts';
import '../page.css';

export function Contracts() {
  const [rows, setRows] = useState<ContractSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [openKey, setOpenKey] = useState<string | null>(null);

  useEffect(() => {
    contractsApi.list().then(setRows).catch(() => setError('Sözleşmeler yüklenemedi'));
  }, []);

  return (
    <div className="page">
      <div className="page-head">
        <div className="page-eyebrow">Bilgilendirme</div>
        <h1>Sözleşmeler</h1>
        <p className="page-lead">Hizmet, iptal/iade ve kişisel verilerin korunması metinleri.</p>
      </div>

      {error && <div className="auth-error">{error}</div>}
      {rows && rows.length === 0 && <div className="placeholder-note">Henüz sözleşme tanımlanmamış.</div>}

      <div className="contract-list">
        {rows?.map((c) => (
          <Card key={c.key} className="contract-item">
            <div className="contract-item-row">
              <span className="contract-item-title">{c.title}</span>
              <Button size="sm" variant="secondary" onClick={() => setOpenKey(c.key)}>Görüntüle</Button>
            </div>
          </Card>
        ))}
      </div>

      <ContractModal contractKey={openKey} onClose={() => setOpenKey(null)} />
    </div>
  );
}
